// Education Skills organized by subcategories
export const EDUCATION_SKILLS_CATEGORIES = [
  {
    name: 'Instructional Design',
    skills: [
      'Curriculum Development', 'Lesson Planning', 'Learning Objectives',
      'Course Design', 'Content Creation', 'Assessment Design',
      'Learning Materials', 'Educational Technology', 'Instructional Methods',
      'Learning Theories', 'Program Development', 'Resource Creation',
      'Curriculum Mapping', 'Learning Pathways', 'Instructional Strategies'
    ]
  },
  {
    name: 'Teaching Methods',
    skills: [
      'Active Learning', 'Project-based Learning', 'Inquiry-based Learning',
      'Differentiated Instruction', 'Cooperative Learning', 'Blended Learning',
      'Problem-based Learning', 'Experiential Learning', 'Flipped Classroom',
      'Peer Learning', 'Adaptive Teaching', 'Scaffolding',
      'Direct Instruction', 'Group Facilitation', 'Individual Instruction'
    ]
  },
  {
    name: 'Assessment and Evaluation',
    skills: [
      'Formative Assessment', 'Summative Assessment', 'Performance Assessment',
      'Rubric Development', 'Feedback Provision', 'Progress Monitoring',
      'Data Analysis', 'Student Evaluation', 'Program Evaluation',
      'Assessment Tools', 'Grading Systems', 'Learning Analytics',
      'Diagnostic Assessment', 'Portfolio Assessment', 'Standardized Testing'
    ]
  },
  {
    name: 'Classroom Management',
    skills: [
      'Behavior Management', 'Time Management', 'Space Organization',
      'Student Engagement', 'Discipline Strategies', 'Classroom Culture',
      'Group Dynamics', 'Conflict Resolution', 'Safety Procedures',
      'Resource Management', 'Schedule Planning', 'Rules Establishment',
      'Student Motivation', 'Classroom Communication', 'Environment Design'
    ]
  },
  {
    name: 'Educational Technology',
    skills: [
      'Learning Management Systems', 'Digital Tools', 'Online Learning',
      'Educational Software', 'Virtual Classrooms', 'Technology Integration',
      'Digital Assessment', 'Multimedia Resources', 'Interactive Technology',
      'E-learning Platforms', 'Digital Content', 'Technology Support',
      'Digital Literacy', 'Tech Troubleshooting', 'Digital Security'
    ]
  },
  {
    name: 'Special Education',
    skills: [
      'Individual Education Plans', 'Adaptive Learning', 'Learning Disabilities',
      'Behavior Support', 'Inclusive Education', 'Differentiated Support',
      'Assistive Technology', 'Special Needs', 'Intervention Strategies',
      'Progress Monitoring', 'Parent Communication', 'Resource Coordination',
      'Accommodation Planning', 'Support Services', 'Student Advocacy'
    ]
  },
  {
    name: 'Student Support',
    skills: [
      'Academic Advising', 'Career Guidance', 'Student Counseling',
      'Learning Support', 'Study Skills', 'Time Management',
      'Goal Setting', 'Progress Tracking', 'Student Development',
      'Mentoring', 'Tutoring', 'Resource Referral',
      'Student Advocacy', 'Crisis Intervention', 'Support Planning'
    ]
  },
  {
    name: 'Professional Development',
    skills: [
      'Teacher Training', 'Workshop Facilitation', 'Coaching',
      'Mentoring', 'Professional Learning', 'Skill Development',
      'Research Integration', 'Best Practices', 'Innovation Implementation',
      'Continuous Learning', 'Leadership Development', 'Collaboration Skills',
      'Reflective Practice', 'Professional Growth', 'Knowledge Sharing'
    ]
  },
  {
    name: 'Educational Leadership',
    skills: [
      'Program Management', 'Staff Development', 'Strategic Planning',
      'Policy Implementation', 'Resource Allocation', 'Quality Assurance',
      'Stakeholder Relations', 'Change Management', 'Vision Setting',
      'Team Building', 'Decision Making', 'Performance Management',
      'Budget Planning', 'Community Relations', 'Innovation Leadership'
    ]
  },
  {
    name: 'Research and Analysis',
    skills: [
      'Educational Research', 'Data Collection', 'Data Analysis',
      'Research Methods', 'Literature Review', 'Action Research',
      'Program Evaluation', 'Outcome Assessment', 'Impact Analysis',
      'Research Design', 'Statistical Analysis', 'Report Writing',
      'Research Publication', 'Grant Writing', 'Research Ethics'
    ]
  },
  {
    name: 'Curriculum Development',
    skills: [
      'Standards Alignment', 'Content Development', 'Learning Objectives',
      'Assessment Planning', 'Resource Creation', 'Scope Sequencing',
      'Integration Planning', 'Cross-curricular Links', 'Curriculum Review',
      'Materials Development', 'Program Design', 'Quality Standards',
      'Curriculum Evaluation', 'Innovation Integration', 'Adaptation Planning'
    ]
  },
  {
    name: 'Educational Administration',
    skills: [
      'School Management', 'Policy Development', 'Budget Administration',
      'Staff Supervision', 'Facility Management', 'Schedule Planning',
      'Record Keeping', 'Compliance Management', 'Safety Protocols',
      'Resource Planning', 'Program Coordination', 'Event Planning',
      'Crisis Management', 'Communication Systems', 'Quality Control'
    ]
  }
];

// Export flattened list for backward compatibility
export const EDUCATION_SKILLS = EDUCATION_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
